export const TYPES = {
    metro: '地铁',
    school: '学校',
    hospital: '医院',
    shopping: '购物',
    bus: '公交',
    food: '美食',
    building: '楼盘'
}

export const HOUSE_ICON = 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/house.png'
export const DEFAULT_DEST_ICON = 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/dest-icon.png'

export const DETS_ICONS = {
    [TYPES.metro]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/metro.png',
    [TYPES.school]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/school.png',
    [TYPES.food]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/food.png',
    [TYPES.hospital]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/hospital.png',
    [TYPES.shopping]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/shopping.png',
    [TYPES.bus]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/bus.png',
    [TYPES.bank]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/bank.png',
    [TYPES.building]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/building.png',
}

export const DETS_A_ICONS = {
    [TYPES.metro]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/metro-a.png',
    [TYPES.school]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/school-a.png',
    [TYPES.food]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/food-a.png',
    [TYPES.hospital]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/hospital-a.png',
    [TYPES.shopping]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/shopping-a.png',
    [TYPES.bus]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/bus-a.png',
    [TYPES.bank]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/bank-a.png',
    [TYPES.building]: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/icons/building-a.png',
}